"use client";

import { Routes } from "@/api";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import React from "react";
import { Button } from "../ui/button";

function useRouteUser() {
  const router = useRouter();
  const { data: session } = useSession();
  // const authDialogProps = useAuthDialogContext();

  const routeUser = () => {
    if (!session) {
      // authDialogProps.onOpenChange(true);
      router.push("#cta");
    } else {
      router.push(Routes.USER_HOME);
    }
  };

  return routeUser;
}

export function LandingPageButton({
  children,
  ...props
}: Omit<React.ComponentProps<typeof Button>, "onClick">) {
  const routeUser = useRouteUser();

  return (
    <Button {...props} onClick={routeUser}>
      {children}
    </Button>
  );
}
